import React, { useState } from "react";
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import axios from "axios";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { StarBorder } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { service } from "../../core/services";
import { useTranslation } from "react-i18next";

const MobileMenu = ({ onClose, categories, open }) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="bottom">
      <Box
        height={"100vh"}
        role="presentation"
        display={"flex"}
        flexDirection={"column"}
      >
        <Box marginLeft={"auto"} marginRight={1} mt={1}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          sx={{ width: "100%", bgcolor: "background.paper" }}
        >
          {categories?.map((category, i) => (
            <RenderCategoryItem openBydefault={i === 0} category={category} />
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

const RenderCategoryItem = ({ category, openBydefault }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(openBydefault);

  return (
    <>
      <ListItem key={category?.id} disablePadding>
        <ListItemButton onClick={() => setOpen((prev) => !prev)}>
          <ListItemText primary={category?.name} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <a
            href={`/products/${category.id}`}
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <ListItemButton
              // onClick={() => handleSubcategoryClick(subcategories)}
              sx={{ pl: 4 }}
            >
              <ListItemText primary={t`View All`} />
            </ListItemButton>
          </a>
          {category?.subcategories.map((subcategories) => (
            <a
              href={`/products/${subcategories.id}`}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <ListItemButton key={subcategories.id} sx={{ pl: 4 }}>
                <ListItemText primary={subcategories.name} />
              </ListItemButton>
            </a>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default MobileMenu;
